export const statusOptions = [
  { label: "Reported", value: "reported" },
  { label: "Under Investigation", value: "under_investigation" },
  { label: "Review Required", value: "review_required" },
  { label: "Closed", value: "closed" },
];

export const roleOptions = [
  { label: "Administrator", value: "Administrator" },
  { label: "Manager", value: "Manager" },
  { label: "Privacy Officer", value: "Privacy Officer" },
  { label: "Operation Management", value: "Operation Management" },
  { label: "Carer/Domestic", value: "Carer/Domestic" },
];

export const commentTypeOptions = [
  { label: "Next of Kin updated/informed", value: "next_of_kin" },
  { label: "Attorney/Advocate updated/informed", value: "attorney_advocate" },
  { label: "Person involved updated/informed", value: "person_involved" },
  { label: "Inspectorate updated/informed", value: "inspectorate" },
];